import { createReducer, on } from '@ngrx/store';
import * as PersonalInfoActions from './personal-info.actions';
import { UserProfileResponse } from '@/app/dashboard/models/dashboard.model';

export interface PersonalInfoState {
  profile: UserProfileResponse | null;
  loading: boolean;
  saving: boolean;
  error: string | null;
  editingEnabled: boolean;
  showCancelModal: boolean;
  completed: boolean;
}

export const initialState: PersonalInfoState = {
  profile: null,
  loading: false,
  saving: false,
  error: null,
  editingEnabled: false,
  showCancelModal: false,
  completed: false,
};

export const personalInfoReducer = createReducer(
  initialState,
  on(PersonalInfoActions.enableEdit, state => ({
    ...state,
    editingEnabled: true,
    showCancelModal: false,
    completed: false,
  })),
  on(PersonalInfoActions.requestCancelEdit, state => ({
    ...state,
    showCancelModal: true,
  })),
  on(PersonalInfoActions.dismissCancelEdit, state => ({
    ...state,
    showCancelModal: false,
  })),
  on(PersonalInfoActions.confirmCancelEdit, state => ({
    ...state,
    editingEnabled: false,
    showCancelModal: false,
    error: null,
  })),
  on(PersonalInfoActions.updateProfile, state => ({
    ...state,
    saving: true,
    error: null,
  })),
  on(PersonalInfoActions.updateProfileSuccess, (state, { profile }) => ({
    ...state,
    saving: false,
    profile,
    editingEnabled: false,
    completed: true,
  })),
  on(PersonalInfoActions.updateProfileFailure, (state, { error }) => ({
    ...state,
    saving: false,
    error,
  }))
);

export const personalInfoFeatureKey = 'personalInfo';
